import type { InvoiceAction } from "../../../../api/types/expenseManagementTypes";
import type { ObjectFieldValues } from "../../../../api/types/objectTypes";

export type { InvoiceAction };

export interface InvoiceActionEligibility {
  canManageInvoices: boolean;
  invoiceIdsPendingMyApproval: Set<string>;
}

export const isInvoiceActionAvailable = (
  invoice: ObjectFieldValues,
  action: InvoiceAction,
  { canManageInvoices, invoiceIdsPendingMyApproval }: InvoiceActionEligibility
): boolean => {
  if (action === "Approve" || action === "Reject") {
    return invoiceIdsPendingMyApproval.has(invoice.id);
  }

  return (
    canManageInvoices &&
    invoice.workflowMetadata?.some(
      (metadata) => !metadata.failureMessage && metadata.availableUserSignals.includes(action)
    ) === true
  );
};

export const getInvoiceIdsForAction = (
  invoices: ObjectFieldValues[],
  action: InvoiceAction,
  eligibility: InvoiceActionEligibility
): string[] =>
  invoices.filter((invoice) => isInvoiceActionAvailable(invoice, action, eligibility)).map((invoice) => invoice.id);
